/**
 * Данные компании. Единственное место, где живут реквизиты и контакты.
 *
 * ВАЖНО: значения с `verified: false` — заглушки, их нужно заменить
 * реальными данными перед публикацией.
 */
const company = {
  name: 'Преобразование',
  fullName: 'ООО «Преобразование»',

  inn: '7807404580',
  kpp: '780701001',
  ogrn: '1267800018540',
  okved: '62.01 — Разработка компьютерного программного обеспечения',

  address:
    '198323, г. Санкт-Петербург, вн. тер. г. муниципальный округ Горелово, тер. Горелово, ш. Аннинское, д. 26А стр. 1, помещ. А 6/3/3',

  phone: '+7 (931) 277-76-95',
  phoneHref: 'tel:+79312777695',
  email: 'accounting@skillblocks.ru',

  tagline: 'Проектирование, разработка и сопровождение информационных систем',
  description:
    'Идеи обретают ценность, когда воплощаются в жизнь',
  stats: [
    { value: '12', label: 'направлений по ОКВЭД', verified: true },
    { value: '62.01', label: 'основной вид деятельности', verified: true },
    { value: 'СПб', label: 'база в Санкт-Петербурге', verified: true },
    { value: '1 день', label: 'ответ на запрос', verified: false },
  ],
};

export default company;
